/* global document */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import patients from '../reducers/patients';

const searchElement = document.getElementById('patient-search-global');
const clinic = searchElement && searchElement.dataset && searchElement.dataset.clinic;
const value = searchElement && searchElement.dataset && searchElement.dataset.value;
const store = createStore(patients, applyMiddleware(thunk));

store.dispatch({
	type: 'CHANGE_PHRASE',
	payload: value !== undefined ? value : '',
});


const renderPatientSearch = () => {
	if (!searchElement) {
		return;
	}

	// eslint-disable-next-line global-require
	const PatientLinkSearch = require('../components/PatientLinkSearch').default;
	render(
		<Provider store={store}>
			<PatientLinkSearch clinic={clinic !== '' ? String(clinic) : null} value={value} />
		</Provider>,
		searchElement,
	);
};

renderPatientSearch();


if (module.hot) {
	module.hot.accept('../reducers/patients', () => {
		// eslint-disable-next-line global-require
		const nextPatients = require('../reducers/patients').default;
		store.replaceReducer(nextPatients);
	});
	module.hot.accept('../components/PatientLinkSearch', renderPatientSearch);
}



// WEBPACK FOOTER //
// ./js/pages/search-global.js